// facets-custom.js

openCustomFacetLink = (event, pathname) => {
    event.preventDefault();
    
    const facetLink = new URL(window.location.href);
    
    // Extract vehicle tag from current URL path if present
    // Format: /collections/all/vehicle-tag or /collections/all/vehicle-tag+other-tag
    const currentPath = window.location.pathname;
    const pathParts = currentPath.split('/');
    const allIndex = pathParts.indexOf('all');
    
    let vehicleTagInPath = null;
    if (allIndex !== -1 && allIndex + 1 < pathParts.length) {
        const tagSegment = pathParts[allIndex + 1];
        if (tagSegment && tagSegment.trim() !== '') {
            // Check if it contains multiple tags (separated by +)
            if (tagSegment.includes('+')) {
                // Extract the first tag (vehicle tag) before the first +
                const tags = tagSegment.split('+');
                vehicleTagInPath = tags[0];
            } else {
                // Single tag - this is likely the vehicle tag
                vehicleTagInPath = tagSegment;
            }
        }
    }
    
    // Set the new pathname
    facetLink.pathname = pathname;
    
    // If we have a vehicle tag, ensure it's preserved in the new path
    if (vehicleTagInPath) {
        const newPathParts = facetLink.pathname.split('/');
        const newAllIndex = newPathParts.indexOf('all');
        
        if (newAllIndex !== -1 && newAllIndex + 1 < newPathParts.length) {
            const newTagSegment = newPathParts[newAllIndex + 1];
            
            // Check if vehicle tag is already in the new path
            const hasVehicleTag = newTagSegment && (
                newTagSegment === vehicleTagInPath || 
                newTagSegment.startsWith(vehicleTagInPath + '+') ||
                newTagSegment.includes('+' + vehicleTagInPath + '+') ||
                newTagSegment.endsWith('+' + vehicleTagInPath)
            );
            
            // If not present, combine vehicle tag with filter tag using +
            if (!hasVehicleTag && newTagSegment) {
                newPathParts[newAllIndex + 1] = vehicleTagInPath + '+' + newTagSegment;
                facetLink.pathname = newPathParts.join('/');
            } else if (!hasVehicleTag) {
                // No filter tag yet, just add vehicle tag
                newPathParts.splice(newAllIndex + 1, 0, vehicleTagInPath);
                facetLink.pathname = newPathParts.join('/');
            }
        }
    }

    window.location.href = facetLink.href;
}
